import { billing } from '@saucelabs/sl-util-axios';

export const retrieveInvoices = () => billing.get('/invoices');
